var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYelloww(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-1271 492)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1271 -492)",
    fill: "#ffa700"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(1276 -487)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelloww);
export default __webpack_public_path__ + "static/media/yelloww.6052c6b8b38de96e741dd96d693dcefb.svg";
export { ForwardRef as ReactComponent };